var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrenada(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0342C24.8366 32.0342 32 24.8707 32 16.0342C32 7.19762 24.8366 0.0341797 16 0.0341797C7.16344 0.0341797 0 7.19762 0 16.0342C0 24.8707 7.16344 32.0342 16 32.0342Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98218 2.8168C9.54999 1.06143 12.6549 0.0341797 16.0001 0.0341797C19.3454 0.0341797 22.4502 1.06143 25.0181 2.8168L16.0001 3.51243L6.98218 2.8168Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 16.0341L14.9786 15.013L14.7075 15.4986L15.9998 16.0341Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68628 4.71999C-1.56209 10.9684 -1.56209 21.0991 4.68628 27.3475C7.26834 24.7654 9.75166 22.2821 16 16.0337L4.68628 4.71999Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3137 4.71999C33.5621 10.9684 33.5621 21.0991 27.3137 27.3475C24.7317 24.7654 22.2484 22.2821 16 16.0337L27.3137 4.71999Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5993C19.0736 21.5993 21.5652 19.1077 21.5652 16.0342C21.5652 12.9606 19.0736 10.469 16 10.469C12.9264 10.469 10.4348 12.9606 10.4348 16.0342C10.4348 19.1077 12.9264 21.5993 16 21.5993Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.469L17.2475 14.3083H21.2848L18.0187 16.6816L19.2661 20.5211L16 18.1482L12.7338 20.5211L13.9815 16.6816L10.7153 14.3083H14.7525L16 10.469Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 0.0341797C15.9981 0.0341797 15.9963 0.0343047 15.9945 0.0343047H16.0052C16.0034 0.0343047 16.0017 0.0341797 15.9999 0.0341797V0.0341797Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0053 0.0341797H15.9946C11.5788 0.0356172 7.5812 1.8258 4.68701 4.71968H27.3128C24.4186 1.8258 20.421 0.0356172 16.0053 0.0341797Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68713 27.3485C7.58251 30.2435 11.5821 32.034 15.9999 32.034C20.4178 32.034 24.4174 30.2435 27.3128 27.3485H4.68713Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 1.77315L16.2592 2.57027H17.0973L16.4193 3.06296L16.6783 3.86009L16.0001 3.36746L15.3221 3.86009L15.5811 3.06296L14.903 2.57027H15.7411L16.0001 1.77315Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.12 1.77315L12.3791 2.57027H13.2172L12.5391 3.06296L12.7982 3.86009L12.12 3.36746L11.442 3.86009L11.701 3.06296L11.0228 2.57027H11.861L12.12 1.77315Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8799 1.77315L20.139 2.57027H20.9771L20.299 3.06296L20.5581 3.86009L19.8799 3.36746L19.2018 3.86009L19.4609 3.06296L18.7827 2.57027H19.6208L19.8799 1.77315Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 28.2079L16.2592 29.0051H17.0973L16.4193 29.4977L16.6783 30.2949L16.0001 29.8022L15.3221 30.2949L15.5811 29.4977L14.903 29.0051H15.7411L16.0001 28.2079Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.12 28.2079L12.3791 29.0051H13.2172L12.5391 29.4977L12.7982 30.2949L12.12 29.8022L11.442 30.2949L11.701 29.4977L11.0228 29.0051H11.861L12.12 28.2079Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8799 28.2079L20.139 29.0051H20.9771L20.299 29.4977L20.5581 30.2949L19.8799 29.8022L19.2018 30.2949L19.4609 29.4977L18.7827 29.0051H19.6208L19.8799 28.2079Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87519 15.7694C5.28613 16.4187 5.093 17.2782 4.44369 17.6892C3.79444 18.1002 2.93494 17.907 2.52394 17.2577C1.77988 16.0822 2.21131 14.1624 2.21131 14.1624C2.21131 14.1624 4.13106 14.5939 4.87519 15.7694V15.7694Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07148 17.7975C4.45566 17.7975 4.7671 17.4861 4.7671 17.1019C4.7671 16.7177 4.45566 16.4063 4.07148 16.4063C3.6873 16.4063 3.37585 16.7177 3.37585 17.1019C3.37585 17.4861 3.6873 17.7975 4.07148 17.7975Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrenada);
export default __webpack_public_path__ + "static/media/grenada.5aba9a92.svg";
export { ForwardRef as ReactComponent };